import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import VSelect from './VSelect.vue';
import VUserCard from './VUserCard.vue';

// Other
import { onMounted, ref, toRefs } from 'vue';
import { PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUserSelector } from '@/mixins/SelectorsApi';


export default /*@__PURE__*/_defineComponent({
  __name: 'VUserSelectorNew',
  props: {
    modelValue: { type: Array as PropType<string[]>, default: () => [] },
    tiny: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    editable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    autofocus: { type: Boolean, default: false },
},
  setup(__props) {

// Svg

// Components
const { t } = useI18n();
const props = __props;
const { modelValue } = toRefs(props);
const userSelector = useUserSelector();

let selectEl = ref<HTMLElement | null>(null);

function contains(userId: string): boolean {
    return props.modelValue.findIndex((id) => id === userId) !== -1;
}

onMounted(() => {
    if (props.autofocus) {
        (selectEl.value?.querySelector('.vs__search') as HTMLInputElement | null)?.focus();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VSelect, {
    ref: "select",
    class: "user-selector-new",
    disabled: __props.disabled,
    filterable: false,
    "model-value": _unref(modelValue),
    multiple: __props.multiple,
    options: _unref(userSelector).options.value,
    placeholder: _unref(t)('select-user'),
    onOpen: _unref(userSelector).prefetch,
    "onOption:selected": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('selected', _unref(userSelector).reduce($event)))),
    onSearch: _unref(userSelector).searchAsync,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (
            _ctx.$emit(
                'update:modelValue',
                Array.isArray($event) ? $event.map(_unref(userSelector).reduce) : _unref(userSelector).reduce($event),
            )
        ))
  }, {
    option: _withCtx((option) => [
      _createElementVNode("div", {
        class: _normalizeClass(["user-selector__select-option", {
                    'user-selector__select-option--selected': contains(option),
                }])
      }, [
        _createVNode(VUserCard, {
          tiny: "",
          user: option.label
        }, null, 8, ["user"])
      ], 2)
    ]),
    "selected-option": _withCtx((option) => [
      _createVNode(VUserCard, {
        tiny: __props.tiny,
        user: option.label
      }, null, 8, ["tiny", "user"])
    ]),
    _: 1
  }, 8, ["disabled", "model-value", "multiple", "options", "placeholder", "onOpen", "onSearch"]))
}
}

})